import type { ListingStatus } from '@/utils/constants/listings/listingStatus'
import type { ListingsProvidersType } from '@/utils/constants/providers/listingsProviders'
import { trackHeapEvent } from '../trackHeapEvent'

export enum ListingsHeapEvents {
  forceSync = 'listings-drawer-force-sync',
  editLocation = 'listings-drawer-edit-location',
  disablePublisher = 'listings-drawer-disable-publisher',
  enablePublisher = 'listings-drawer-enable-publisher',
  acceptReservations = 'listings-drawer-accept-reservations',
}

export interface ListingTrackingDataProps {
  provider: ListingsProvidersType
  storeId: string
}

export type ListingTrackingDataOptOutInProps = ListingTrackingDataProps & {
  listingStatus: ListingStatus | string
  errorCode: string
}

export type ListingTrackingDataForceSync = ListingTrackingDataProps & {
  lastListingStatus: ListingStatus
}

export type ListingTrackingDataAcceptReservationsProps = {
  status: 'Success' | 'Fail'
}

export const listingsTrackingEvents = {
  editLocation(trackData: ListingTrackingDataProps) {
    trackHeapEvent(ListingsHeapEvents.editLocation, trackData)
  },
  forceSync(trackData: ListingTrackingDataForceSync) {
    trackHeapEvent(ListingsHeapEvents.forceSync, trackData)
  },
  disablePublisher(trackData: ListingTrackingDataOptOutInProps) {
    trackHeapEvent(ListingsHeapEvents.disablePublisher, trackData)
  },
  enablePublisher(trackData: ListingTrackingDataOptOutInProps) {
    trackHeapEvent(ListingsHeapEvents.enablePublisher, trackData)
  },
  acceptReservations(trackData: ListingTrackingDataAcceptReservationsProps) {
    trackHeapEvent(ListingsHeapEvents.acceptReservations, trackData)
  },
}
